import { Component, Input, Output, OnInit, ViewEncapsulation, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductService } from 'services/product.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'product-application' }
})
export class ProductItemComponent implements OnInit {
  // Input Decorotor
  @Input() product;
  @Input() isWishlistOpen = false;

  @Output() newItemEvent = new EventEmitter<any>();

  // Public
  public isInCart = false;
  public loadingButton = false;

  /**
   *
   * @param {ProductService} _productService
   */
  constructor(private _productService: ProductService, private _httpClient: HttpClient    ) {
    
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle Wishlist
   *
   * @param product
   */
  toggleWishlist(product) {
    if (product.isInWishlist === true) {      
      // this._productService.removeFromWishlist(product.id).then(res => {
      //   product.isInWishlist = false;
      // });
    } else {
      // this._productService.addToWishlist(product.id).then(res => {
      //   product.isInWishlist = true;
      // });
    }
  }

  changeStatus(type){
    this.loadingButton = true;
    switch (type) {
      case 'active':
        this.product.status = 'inactive';
        break;
    
      default:
        this.product.status = 'active';
        break;
    }
    new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/plan`, this.product).subscribe(response => {
        //this.addNewItem(response);
        resolve(response);
        this.loadingButton = false;
      }, reject);
    })
    .catch((error) => {
      this.loadingButton = false;
    })
  };

  /**
   * Add To Cart
   *
   * @param product
   */
  addToCart(product) {
    // this._productService.addToCart(product.id).then(res => {
    //   product.isInCart = true;
    // });
  }
  /**
   * Open item
   *
   * @param value
   */
  openItem(value: any) {
    this.newItemEvent.emit(value);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnInit(): void {}
}
